export default __webpack_public_path__ + "static/1366-e61b73d8b343553cb357aad36c5e7134.gif";